angular.module('content.widgets.studentNotesWidget', [
  'content.widgets.studentNotesWidgetController'
])

/**
 * Preview and author student notes
 *
 * @class StudentNotesWidget
 * @constructor
 * @module content.widgets.StudentNotesWidget
 * @example
 *   <student-notes-widget
 *     model="form.model">
 *   </student-notes-widget>
 */
.directive('studentNotesWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/studentNotesWidget/student-notes-widget-edit.html';
        }
        return 'content/source/content/widgets/studentNotesWidget/student-notes-widget.html';
      },
      controller: 'studentNotesWidgetController'
    };
  }
]);
